import { render, staticRenderFns } from "./CurrentDateAndTimeDisplay.vue?vue&type=template&id=05c8c0b1&scoped=true&"
import script from "./CurrentDateAndTimeDisplay.vue?vue&type=script&lang=js&"
export * from "./CurrentDateAndTimeDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c8c0b1",
  null
  
)

export default component.exports